// Module
var code = `<div class="custom-date-header">
    <button (click)="previousClicked()"
            id="datepickerDialogPrevious"
            tid="datepickerDialogPrevious">
                <span class="Icon u-strokeBlue Icon--24">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="24"
                         height="24"
                         viewBox="0 0 72 72">
                        <path fill="none"
                              stroke="#838383"
                              stroke-width="3.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              d="M49.52 62L22.48 36.008 49.52 10">
                        </path>
                    </svg>
                </span>
    </button>
    <span id="periodLabel" tid="periodLabel">{{periodLabel}}</span>
    <button (click)="nextClicked()"
            id="datepickerDialogNext"
            tid="datepickerDialogNext">
                <span class="Icon u-strokeBlue Icon--24">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="24"
                         height="24"
                         viewBox="0 0 72 72">
                        <path fill="none"
                              stroke="#838383"
                              stroke-width="3.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              d="M22.48 10l27.04 25.992L22.48 62">
                        </path>
                    </svg>
                </span>
    </button>
</div>`;
// Exports
module.exports = code;